import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useApiView } from './useApiView';
import { IntegrationsView } from '../views/integrations/IntegrationsView/IntegrationsView';

interface AuthState {
  authReducers?: { authenticatedUser?: { attributes?: { sub?: string } } };
}

export const useIntegrationsView = (enabled = true) => {
  const subject = useSelector((state: AuthState) => state.authReducers?.authenticatedUser?.attributes?.sub);
  const scopedView = useMemo(() => ({ subject, view: new IntegrationsView(enabled) }), [enabled, subject]);
  return useApiView(scopedView.view).state;
};
